import { SagaIterator } from '@redux-saga/core';
import { all, takeLatest, put, call } from 'redux-saga/effects';
import { isEmpty } from 'lodash';

import { statusMessageSaga } from 'pages/AppManagement/saga';
import { RequestSagaParams } from 'types';

import * as AssetActions from '../AssetsManagement/slice';
import * as UploadActions from '../UploadManagement/slice';
import * as Actions from './slice';
import * as Endpoints from './endpoint';
import { mapUploadMediaFile, getMappedConversionForm, getMappedConversionFormForUpdating } from './mappings';

export function* getCTAList({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.getConversionsByMarketer, payload);
    const data =
      response.data._embedded && response.data._embedded.conversions && response.data._embedded.conversions.length > 0
        ? response.data._embedded.conversions
        : [];
    yield put(Actions.fetchCTAListSuccess(data));
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchCTAListFailure(error));
  }
}

export function* getConversionDetails({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.getConversionDetails, payload);
    const data = response.data;
    yield put(Actions.fetchConversionDetailSuccess(data));
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchConversionDetailFailure(error));
  }
}

export function* postConversion({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.postConversion, getMappedConversionForm(payload.data));
    if (!isEmpty(response.data) && response.data.id) {
      if (payload.data.property.file) {
        const assetsResponse = yield call(
          Endpoints.postConversionAssets,
          response.data.id,
          mapUploadMediaFile({ file: payload.data.property.file })
        );

        if (!isEmpty(assetsResponse.data) && assetsResponse.data?._embedded?.assets[0]?._links?.access?.href) {
          yield call(Endpoints.updateConversion, {
            id: response.data.id,
            data: {
              ...getMappedConversionForm(payload.data),
              icon: assetsResponse.data?._embedded?.assets[0]?._links?.access?.href
            }
          });
        }
      }
    }
    if (payload.callback) {
      payload.callback();
      // yield put(Actions.fetchCTAList({}));
      yield call(statusMessageSaga, { type: 'success', message: 'Successfully added new converstion' });
    }
    yield put(Actions.postConversionSuccess());
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.detail });
    yield put(Actions.postConversionFailure(error));
  }
}

export function* updateConversion({ payload }: RequestSagaParams): SagaIterator {
  try {
    const newFormData = payload.data;
    const previousData = payload.conversion;
    if (newFormData.property.file instanceof File) {
      const assetsResponse = yield call(
        Endpoints.postConversionAssets,
        previousData.id,
        mapUploadMediaFile({ file: newFormData.property.file })
      );

      if (!isEmpty(assetsResponse.data) && assetsResponse.data?._embedded?.assets[0]?._links?.access?.href) {
        yield call(Endpoints.updateConversion, {
          id: previousData.id,
          data: {
            ...getMappedConversionForm(newFormData),
            icon: assetsResponse.data?._embedded?.assets[0]?._links?.access?.href
          }
        });
      }
    } else {
      const formData = getMappedConversionFormForUpdating(previousData, newFormData);
      if (formData) {
        const response = yield call(Endpoints.updateConversion, {
          id: previousData.id,
          data: formData
        });
      }
    }

    // const response = yield call(Endpoints.updateConversion, {
    //   id: payload.data.id,
    //   data: {
    //     ...getMappedConversionForm(payload.data)
    //   }
    // });
    // if (!isEmpty(response.data) && response.data.id) {
    //   if (payload.data.file && typeof payload.data.file !== 'string') {
    //     const assetsResponse = yield call(
    //       Endpoints.postConversionAssets,
    //       response.data.id,
    //       mapUploadMediaFile({ file: payload.data.file })
    //     );
    //     if (!isEmpty(assetsResponse.data) && assetsResponse.data?._embedded?.assets[0]?._links?.access?.href) {
    //       yield call(Endpoints.updateConversion, {
    //         id: response.data.id,
    //         data: {
    //           ...getMappedConversionForm(payload.data),
    //           icon: assetsResponse.data?._embedded?.assets[0]?._links?.access?.href
    //         }
    //       });
    //     }
    //   }
    // }
    if (payload.callback) {
      payload.callback();
      // yield put(Actions.fetchCTAList({}));
      yield call(statusMessageSaga, { type: 'success', message: 'Successfully updated the converstion' });
    }
    yield put(Actions.updateConversionSuccess());
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.detail });
    yield put(Actions.updateConversionFailure(error));
  }
}

export function* getForms({ payload }: RequestSagaParams): SagaIterator {
  console.log('getForms');
  try {
    const response = yield call(Endpoints.getConversionFormType, payload);
    const data =
      response.data._embedded && response.data._embedded.forms && response.data._embedded.forms.length > 0
        ? response.data._embedded.forms
        : [];
    yield put(Actions.fetchFormsSuccess(data));
    yield put(AssetActions.fetchFormsSuccess(data));
    yield put(UploadActions.fetchFormsSuccess(data));
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchFormsFailure(error));
    yield put(AssetActions.fetchFormsFailure(error));
    yield put(UploadActions.fetchFormsFailure(error));
  }
}

export function* postFormConversion({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.postFormConversion, payload.id, getMappedConversionForm(payload.data));
    if (!isEmpty(response.data) && response.data.id) {
      const assetsResponse = yield call(
        Endpoints.postConversionAssets,
        response.data.id,
        mapUploadMediaFile({ file: payload.data.file })
      );
      // if (!isEmpty(assetsResponse.data) && assetsResponse.data?._embedded?.assets[0]?._links?.access?.href) {
      //   yield call(Endpoints.updateConversion, {
      //     id: response.data.id,
      //     data: {
      //       ...getMappedConversionForm(payload.data),
      //       icon: assetsResponse.data?._embedded?.assets[0]?._links?.access?.href
      //     }
      //   });
      // }
    }
    if (payload.callback) {
      payload.callback();
    }
    yield call(statusMessageSaga, { type: 'success', message: 'Successfully added new converstion' });
    yield put(Actions.postConversionSuccess());
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.detail });
    yield put(Actions.postConversionFailure(error));
  }
}

export function* updateFormConversion({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.updateConversion, {
      id: payload.data.id,
      data: {
        ...getMappedConversionForm(payload.data)
      }
    });
    if (!isEmpty(response.data) && response.data.id) {
      if (payload.data.file && typeof payload.data.file !== 'string') {
        const assetsResponse = yield call(
          Endpoints.postConversionAssets,
          response.data.id,
          mapUploadMediaFile({ file: payload.data.file })
        );
        if (!isEmpty(assetsResponse.data) && assetsResponse.data?._embedded?.assets[0]?._links?.access?.href) {
          yield call(Endpoints.updateConversion, {
            id: response.data.id,
            data: {
              ...getMappedConversionForm(payload.data),
              icon: assetsResponse.data?._embedded?.assets[0]?._links?.access?.href
            }
          });
        }
      }
      if (payload.data.form) {
        const formResponse = yield call(Endpoints.putFormConversion, payload.data.form, response.data.id);
      }
    }
    if (payload.callback) {
      payload.callback();
      yield call(statusMessageSaga, { type: 'success', message: 'Successfully updated the converstion' });
    }
    yield put(Actions.updateConversionSuccess());
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.detail });
    yield put(Actions.updateConversionFailure(error));
  }
}

export function* deleteConversion({ payload }: RequestSagaParams): SagaIterator {
  try {
    yield call(Endpoints.deleteConversion, payload.id);
    yield put(Actions.fetchCTAList({}));
    if (payload.callback) {
      yield call(payload.callback);
    }
    yield put(Actions.deleteConversionSuccess());
    yield call(statusMessageSaga, { type: 'success', message: 'Conversion removed' });
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.deleteConversionFailure(error));
  }
}

export function* CTAManagementWatcherSaga(): SagaIterator {
  yield all([
    yield takeLatest(Actions.fetchCTAList.type, getCTAList),
    yield takeLatest(Actions.postConversion, postConversion),
    yield takeLatest(Actions.fetchConversionDetail.type, getConversionDetails),
    yield takeLatest(Actions.updateConversion.type, updateConversion),
    yield takeLatest(Actions.fetchForms.type, getForms),
    yield takeLatest(AssetActions.fetchForms.type, getForms),
    yield takeLatest(UploadActions.fetchForms.type, getForms),
    yield takeLatest(Actions.postFormConversion.type, postFormConversion),
    yield takeLatest(Actions.updateFormConversion.type, updateFormConversion),
    yield takeLatest(Actions.deleteConversion.type, deleteConversion)
  ]);
}

export default CTAManagementWatcherSaga;
